import React from 'react';
import * as yup from 'yup';
import TextField from 'components/Form/FormTextField';
import Form from 'components/Form/Layout';
import validateForm from 'utils/Validator';
import LinkInvitationFooter from 'components/LinkInvitation/Footer';

type FormProps = {
  onSubmit: ( values: any ) => void;
};

function LinkValidateEmailForm( { onSubmit }: FormProps ) {
  const validationSchema = yup.object( {
    email: yup.string()
      .email( 'Introduce un email válido' )
      .required( 'El email es obligatorio' ),
  } );

  const validate = validateForm( validationSchema );

  return (
    <Form
      validate={validate}
      onSubmit={onSubmit}
      body={( form ) => (
        <>
          <h2 className="text--black4">Validación de acceso</h2>

          <p className="text--gray20 mt-4 pt-2">
            Por favor, introduzca la dirección de correo electrónico con la cual
            se creó la invitación para validar su identidad.
          </p>

          <div className="mt-4">
            <TextField
              field="email"
              label="Correo electrónico"
              placeholder="ejemplo@correo.com"
            />
          </div>

          <LinkInvitationFooter
            onNext={form.submit}

          />
        </>
      )}
    />
  );
}

export default LinkValidateEmailForm;
